//Error 404 page for incorrect URL paths
export function NotFound() {
  return (
    <div>
      <h1>Error 404</h1>
      <h3>This page could not be found :(((</h3>
    </div>
  );
}
